import hotkeys from "hotkeys-js";
import { useCallback, useEffect } from "react";

export const useHotKeys = (keys, callback, deps = []) => {
  const memoisedCallback = useCallback(callback, deps);

  useEffect(() => {
    hotkeys(keys, memoisedCallback);

    return () => hotkeys.unbind(keys, memoisedCallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memoisedCallback]);
};
